export const storageVariables = {
    answers: 'onmat_exercise'
};